import { EntityTypes } from "../helpers/constant";
export default {
  methods: {
    getProfileName(entityType, clientName, partnerinfo, parentClientInfo) {
      let profileNames = [];
      if (entityType == EntityTypes.both) {
        if (parentClientInfo >= 0)
          profileNames.push(
            this.getprofileName(
              this.clientInformation[parentClientInfo].clientName,
              this.clientInformation[parentClientInfo].entityType
            )
          );
        if (partnerinfo >= 0)
          profileNames.push(
            this.getprofileName(
              this.clientInformation[partnerinfo].clientName,
              this.clientInformation[parentClientInfo].entityType
            )
          );
      } else {
        profileNames.push(this.getprofileName(clientName, entityType));
      }
      return profileNames;
    },
    getprofileName(clientName, entityType) {
      let profileName = "";
      let parts = clientName.replace(/(^MRS|MR|MISS)/gi, "").toUpperCase();
      parts = parts.trim().split(' ');

      if (parts.length === 1) 
      profileName += `${parts[0].charAt(0)}`;
      else 
      profileName += `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`;
      
      return {
        tag: profileName,
        name: clientName,
        type: entityType,
      };
    },
  },
};
